import React from "react";
import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";

export const Footer = () => {
  const cols = [
    { title: "Platform", links: [
      { label: "AI Analyzer", to: "/page/ai-analyzer" },
      { label: "Trade Journal", to: "/page/trade-journal" },
      { label: "Forex Tools", to: "/page/forex-tools" },
      { label: "Community", to: "/page/community" },
    ] },
    { title: "Academy", links: [
      { label: "Curriculum", to: "/page/curriculum" },
      { label: "Market Structure", to: "/page/market-structure" },
      { label: "SMC", to: "/page/smc" },
      { label: "Psychology", to: "/page/psychology" },
    ] },
    { title: "Company", links: [
      { label: "About", to: "/page/about" },
      { label: "Careers", to: "/page/careers" },
      { label: "Contact", to: "/contact" },
      { label: "Blog", to: "/page/blog" },
    ] },
  ];
  return (
    <footer className="relative border-t border-white/10 bg-[#070A0E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="h-9 w-9 rounded-md bg-brand/15 border border-brand/40 grid place-items-center">
                <TrendingUp className="h-5 w-5 text-brand" />
              </div>
              <div className="leading-none">
                <div className="font-heading font-extrabold tracking-tight text-[15px]">NETROY</div>
                <div className="font-data text-[9px] uppercase tracking-[0.25em] text-slate-500">Forex Academy</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
              AI-powered chart intelligence, live market data and an elite community — built for serious traders.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-data text-[11px] uppercase tracking-widest text-slate-500 mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}><Link to={l.to} className="text-sm text-slate-400 hover:text-brand transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-data text-[11px] text-slate-600">© 2026 Netroy Forex Academy. All rights reserved.</p>
          <p className="font-data text-[11px] text-slate-600">Trading involves risk. Educational content only — not financial advice.</p>
        </div>
      </div>
    </footer>
  );
};
